import Axios from "@/utils/Axios";
import config from "@/config";

const postWorkApis = {
  post: "/opus/publish",
};

export interface ServerPostItemType {
  meta_json: any; // 图片的 meta 信息
  image_url: string; // 图片地址
  is_ai: 1 | 2; // 是否ai生成图 1是 2否
  image_id?: string | number;
}
export interface PostWorkRequestData {
  title: string; //作品标题
  describe: string; // 作品描述
  is_open: 1 | 2; // 是否公开  1是 2否
  opus_image: ServerPostItemType[]; // 作品图片
}
export const postPostWork = (data: PostWorkRequestData) =>
  Axios.post(postWorkApis.post, data, {}, config.creatorUrl);
